import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import ApplicationLayoutBodyBottomBar from '@rio-cloud/rio-uikit/ApplicationLayoutBodyBottomBar';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import useWindowResize from '@rio-cloud/rio-uikit/useWindowResize';

import './App.css';
import { type PropsWithChildren, useState } from 'react';

import SessionExpiredInfo from '../components/SessionExpiredInfo';
import AppHeader from '../features/header/AppHeader';
import { isRunningInIframe } from '../utils';
import { EulaConsentFooter } from '../features/man-eula/EulaConsentFooter';
import { newInnerHeight, useShouldShowBodyBottomBarDueToHeight, useShowActionButtons } from '../data/appSlice';
import { useAppDispatch } from '../configuration/setup/hooks';

const inIframe = isRunningInIframe();

const computeHeight = (innerWidth: number) => {
    if (innerWidth < 480) {
        return 225;
    } else if (innerWidth < 768) {
        return 200;
    } else if (innerWidth < 992) {
        return 175;
    } else if (innerWidth < 1200) {
        return 175;
    } else if (innerWidth < 1700) {
        return 150;
    } else {
        return 150;
    }
};

const AppLayout = ({ children }: PropsWithChildren) => {
    const dispatch = useAppDispatch();

    const showActionButtons = useShowActionButtons();
    const dueToHeight = useShouldShowBodyBottomBarDueToHeight();

    const [bottomBarHeight, setBottomBarHeight] = useState(computeHeight(window.innerWidth));

    useWindowResize(() => {
        setBottomBarHeight(computeHeight(window.innerWidth));
        dispatch(newInnerHeight(window.innerHeight));
    });

    return (
        <ApplicationLayout data-testid='app-layout'>
            {!inIframe && (
                <ApplicationLayout.Header>
                    <AppHeader />
                </ApplicationLayout.Header>
            )}
            <ApplicationLayout.Body
                bottomBarHeight={bottomBarHeight}
                bottomBar={
                    showActionButtons &&
                    dueToHeight &&
                    !inIframe && (
                        <ApplicationLayoutBodyBottomBar>
                            <EulaConsentFooter inBodyBottomBar={true} />
                        </ApplicationLayoutBodyBottomBar>
                    )
                }
            >
                <NotificationsContainer />
                {!inIframe && <SessionExpiredInfo />}
                {children}
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
};

export default AppLayout;
